import LoggerService from '../services/logger.service';

export default function ({ app }, inject) {
    const logger = LoggerService(process.server, app);
    inject('logger', logger);
}
